"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { SingleProductDescriptionFocused } from "../singleProduct/singleProductDescriptionFocused";
import { SingleProductImageFocused } from "../singleProduct/singleProductImageFocused";
import { giftCardItem, giftCardRoute } from "@/utils/giftCardUtils";
import { ItemList } from "../itemList/itemList";

export const Items = ({
  itemTemplate,
  items,
  isRetailMerchant,
  merchantName,
}: any) => {
  return (
    <div className="pt-8">
      <ItemList listType={itemTemplate?.toLowerCase()}>
        {itemTemplate?.toLowerCase() === "image focused" &&
          items.map((product: any) => (
            <Link
              href={
                product.id !== giftCardItem.id
                  ? `/${product.id}`
                  : giftCardRoute
              }
              key={product.id}
            >
              <SingleProductImageFocused
                product={product}
                isRetailMerchant={isRetailMerchant}
              />
            </Link>
          ))}
        {itemTemplate?.toLowerCase() === "description focused" &&
          items.map((product: any) => (
            <Link
              href={
                product.id !== giftCardItem.id
                  ? `/${product.id}`
                  : giftCardRoute
              }
              key={product.id}
            >
              <SingleProductDescriptionFocused
                merchantName={merchantName}
                product={product}
                key={product.id}
                isRetailMerchant={isRetailMerchant}
              />
            </Link>
          ))}
      </ItemList>
    </div>
  );
};
